import { WSQueryConfig } from "@ws-react-query";
import { IPayeeResponse } from "@wingspanhq/payments/dist/interfaces";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSQuery } from "../../helpers";
import { QUERY_PAYEE } from "../keys";
import { getPayee } from "../../../services/payees";
import { useXWingspanPayerId } from "../../../modules/Payees/routes/RoutePayeeDetails/useXWingspanPayerId";

export const useQueryPayee = (
  payeeId: string,
  config?: WSQueryConfig<IPayeeResponse, WSServiceError>
) => {
  const xWingspanPayerId = useXWingspanPayerId();

  return useWSQuery<IPayeeResponse, WSServiceError>(
    [QUERY_PAYEE, payeeId, xWingspanPayerId],
    async () => {
      return await getPayee(payeeId, xWingspanPayerId);
    },
    {
      ...config
    }
  );
};
